import React from "react";
import {
  Card, CardContent
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

import I18n from "../../../../../../base/i18n.js.jsx";
import { itemWithKeys } from "../../../../../../utils/utils.js.jsx";
import FormFields from "../../../../../../base/form/form_fields.js.jsx";

import pageStyles from "../../../../../styles/page_styles.js.jsx";
import { infoPageStyles } from "../../../../base_info_page.js.jsx";
import cardStyles from "./card_styles.js";

import { AdminAddressUserModel } from "../../../../../../models/users/admin/address_user_model.js";
import { AdminUserAddressInfoModel } from "../../../../../../models/users/admin/user_address_info_model.js"

const styles = theme => ({
});

const AddressCard = (props) => {

  const { classes, onItemChanged, errorData } = props;

  const user = Object.assign({}, props.user) || {};
  user.personalInfo = itemWithKeys(user.personalInfo, AdminUserAddressInfoModel.formFieldsWhitelist(user.personalInfo))

  const formFields = AdminAddressUserModel.formFields({item: user});

  const addressFields = ["personalInfo"];

  return (
    <Card className = { classes.card }>
      <CardContent>
        <div className = { classes.cardTitle } >
          { I18n.t("admin.users.user.field_group.address")}
        </div>
        <FormFields formFields = { formFields.filter(field => addressFields.includes(field.name)) }
                    item = { itemWithKeys(user, addressFields) }
                    errorData = { errorData }
                    onItemChange = { onItemChanged } />
      </CardContent>
    </Card>
  );
}

AddressCard.defaultProps = {
}

export default withStyles(
  (theme) => ({
    ...pageStyles(theme),
    ...infoPageStyles(theme),
    ...cardStyles(theme),
    ...styles(theme)
  }),
  { withTheme: true }
)(AddressCard);
